/**
 *  AenaHighlightedPointsList script file
**/
import { mapGetters } from 'vuex'
import { GETTERS } from '@/store'

export default {
  name: 'AenaHighlightedPointsList',
  mixins: [],
  components: {},
  props: {
    highlighted: {
      type: Array,
      required: true
    },
    outdoorDisabled: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$refs.scroller.addEventListener('mouseover', () => {
      this.$refs.scroller.style.visibility = 'visible'
    })

    this.$refs.scroller.addEventListener('mouseout', () => {
      this.$refs.scroller.style.visibility = 'hidden'
    })
  },
  computed: {
    ...mapGetters({
      isMobile: GETTERS.GET_IS_MOBILE
    })
  },
  methods: {
    selectPoint (category) {
      this.$emit('onSelectPoint', category)
    },
    allPoints () {
      this.$emit('onAllPoints')
    }
  }
}
